import { render, staticRenderFns } from "./AssetInformationGeneralInfo.vue?vue&type=template&id=01a190b1&scoped=true&"
import script from "./AssetInformationGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./AssetInformationGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./AssetInformationGeneralInfo.vue?vue&type=style&index=0&id=01a190b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a190b1",
  null
  
)

export default component.exports